<template>
  <div v-if="population">
    <h1>Population</h1>
    <v-btn :to="{name:'populations'}">
      <v-icon>chevron_left</v-icon>Populations
    </v-btn>
    <h3>Population</h3>
    <table>
      <tr>
        <th>Id</th>
        <td>{{population.id}}</td>
      </tr>
      <tr>
        <th>Name</th>
        <td>{{population.name}}</td>
      </tr>
      <tr>
        <th>Latitude</th>
        <td>{{population.lat}}</td>
      </tr>
      <tr>
        <th>Longitude</th>
        <td>{{population.lon}}</td>
      </tr>
    </table>
    <template v-if="county">
      <h3>County</h3>
      <table>
        <tr>
          <th>Id</th>
          <td>
            <router-link :to="{name:'county'}">{{county.id}}</router-link>
          </td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{county.name}}</td>
        </tr>
      </table>
    </template>
    <v-select
      :items="branches"
      label="Branch"
      v-model="population.entityid"
      item-value="id"
      item-text="name"
      outline
      @change="updateBranch"
      v-if="branches"
    />
    <GmapMap
      :center="{lat:mapModel.latLng.lat, lng:mapModel.latLng.lng}"
      :zoom="18"
      map-type-id="hybrid"
      style="width: 100%; height: 400px;"
      v-if="mapModel"
    >
      <GmapMarker
        :position="mapModel.position"
        :clickable="true"
        :draggable="true"
        :title="mapModel.title"
        @click="center=mapModel.position"
      />
    </GmapMap>
    <h3>Articles</h3>
    <v-btn @click="generatePopulation">
      <v-icon>refresh</v-icon>Generate articles
    </v-btn>
    <Articles :articles="articles" />
    <v-dialog v-model="generatingVisible" persistent width="300">
      <v-card color="error" dark>
        <v-card-text>
          <span>{{generatingContent}}</span>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :multi-line="false" :timeout="1500" :top="true">
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Articles from "@/components/extras/Articles";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Population",
  metaInfo() {
    return {
      title: "Population",
      titleTemplate: "%s - SEO - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { Articles },
  data() {
    return {
      population: null,
      branches: null,
      county: null,
      mapModel: null,
      articles: null,
      generatingVisible: false,
      generatingContent: null,
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    fetchPopulation() {
      nbmlaw
        .get(`/cors/admin/extras/populations/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.population = response.data;
          this.fetchCounty();
          this.loadMapModel();
        });
    },
    fetchBranches() {
      nbmlaw
        .get(`/cors/admin/directory/branches`)
        .then(response => {
          // console.log(response.data);
          this.branches = response.data;
        })
        .catch(() => {});
    },
    fetchCounty() {
      nbmlaw
        .get(`/cors/admin/extras/counties/${this.population.countyid}`)
        .then(response => {
          // console.log(response.data);
          this.county = response.data;
          this.loadMapModel();
        });
    },
    fetchArticles() {
      nbmlaw
        .get(`/cors/admin/extras/populations/${this.$route.params.id}/articles`)
        .then(response => {
          // console.log(response.data);
          this.articles = response.data;
        });
    },
    loadMapModel() {
      if (this.population && this.population.lat && this.population.lon) {
        const lat = Number(this.population.lat);
        const lng = Number(this.population.lon);
        const title = this.population.name;
        this.mapModel = {
          latLng: {
            lat,
            lng
          },
          position: {
            lat,
            lng
          },
          title
        };
      }
    },
    generatePopulation() {
      this.generatingVisible = true;
      this.generatingContent = "Waiting for server to generate articles...";
      nbmlaw
        .put(
          `/cors/admin/extras/populations/${this.$route.params.id}/articles`,
          null
        )
        .then(() => {
          // console.log(response.data);
          this.fetchArticles();
          this.generatingVisible = false;
        });
    },
    updateBranch() {
      nbmlaw
        .put(
          `/cors/admin/extras/populations/${this.$route.params.id}/${this.population.entityid}`,
          null
        )
        .then(() => {
          // console.log(response.data);
          this.snackbar = true;
          this.snackbarText = "Branch updated";
        });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchPopulation();
        this.fetchArticles();
        this.fetchBranches();
      }
    }
  }
};
</script>
